import getActiveConsentOneTrustIds from "./getActiveConsentOneTrustIds";

const getCookieConsent = async () => {
  // 1 Means DONT use personalised ads
  // 0 Means use personalised ads

  const activeConsentCategoryIds = {
    ALLOW_ADS: 0,
    DENY_ADS: 1
  };

  const ACTIVE_CONSENT_ID = "C0004";

  const hasPersonalisedAds = await getActiveConsentOneTrustIds();

  return hasPersonalisedAds.includes(ACTIVE_CONSENT_ID)
    ? activeConsentCategoryIds.ALLOW_ADS
    : activeConsentCategoryIds.DENY_ADS;
};

export default getCookieConsent;
